import React from 'react';
import PropTypes from 'prop-types';
import {defaultAddressFormatter, getSuggestions} from "./utils";

export default function withDadata(properties) {
	return WrappedComponent => {
		class WithDadata extends React.Component {
			static propTypes = {
				onChange: PropTypes.func,
				handleNoSuggestions: PropTypes.func,
				searchIntercept: PropTypes.func,
				addressFormatter: PropTypes.func,
				disabled: PropTypes.bool,
				autoload: PropTypes.bool,
				count: PropTypes.number,
				fromCount: PropTypes.number,
				connectionString: PropTypes.string,
				query: PropTypes.string,
				token: PropTypes.string,
				className: PropTypes.string,
				defaultValue: PropTypes.string,
				fromBound: PropTypes.string,
				toBound: PropTypes.string,
				value: PropTypes.any,
				parts: PropTypes.array,
			};

			static defaultProps = {
				fromCount: 3,
				count: 10,
				handleNoSuggestions: () => {
				},
				searchIntercept: null,
			};

			constructor(props, context) {
				super(props, context);

				this.state = {
					query: this.props.query ? this.props.query : '',
					suggestions: [],
					suggestionsVisible: true,
				};
			}

			/**
			 * Изменение значения в текстовом поле
			 * @param value
			 */
			onInputChange = value => {
				// Если количество символов достаточное для поиска
				if (value.length >= properties.fromCount) {
					this.setState({
						query: value,
						suggestionsVisible: true
					}, () => this.fetchSuggestions(value));
				}

				// Если строка поиска пустая, удаляем подсказки
				if (value.length === 0) {
					this.setState({
						suggestions: []
					});
				}
			};

			/**
			 * Действие на фокус вне элемента
			 */
			onBlur = () => {
				if (this.state.suggestions.length === 0) {
					this.props.handleNoSuggestions();
				}
			};

			fetchSuggestions = query => {
				const connectionString = this.props.connectionString || properties.connectionString;
				const {token, fromBound, toBound, count, parts} = this.props;
				const {searchIntercept = data => data, addressFormatter = defaultAddressFormatter} = this.props;
			
				this.request && this.request.abort();

				const {request, promise} = getSuggestions(query, {
					connectionString,
					token,
					count,
					parts,
					fromBound,
					toBound,
					searchIntercept,
					addressFormatter
				});

				this.request = request;

				promise.then(({suggestions, requestId}) => {
					if (this.request && this.request.id === requestId) {
						this.setState({suggestions});
					}
				});
			};

			/**
			 * Клик по варианту из подсказок
			 * @param suggestionValue
			 */
			onSuggestionClick = suggestionValue => {
				// Поиск индекса варианта в списке
				const address = this.state.suggestions.find(s => s.value === suggestionValue);

				if (address) {
					this.setState({
						query: address.value,
						suggestionsVisible: false,
					}, () => this.fetchSuggestions(address.value));

					if (this.props.onChange) {
						this.props.onChange(address);
					}
				}
			};

			render() {
				const {
					onInputChange,
					onBlur,
					onSuggestionClick,
				} = this;

				const {
					query,
					suggestions,
					suggestionsVisible,
				} = this.state;

				return (
					<WrappedComponent
						query={query}
						suggestions={suggestions}
						suggestionsVisible={suggestionsVisible}
						connectionString={this.props.connectionString || properties.connectionString}
						onSuggestionClick={onSuggestionClick}
						onInputChange={onInputChange}
						onBlur={onBlur}
						{...this.props}
					/>
				);
			}
		}

		WithDadata.displayName = `WithDadata(${ WrappedComponent.displayName || WrappedComponent.name || 'Component' })`;

		return WithDadata;
	};
}
